// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"y9-z"};